import React from "react";
import { useHistory } from "react-router-dom";
import { SetupLayout } from "../../../components/SetupFlow/SetupFlowLayout";
import { SetupInternationalAccount } from "../../../Invoices/components/SetupInternationalAccount/SetupInternationalAccount";

export const PayoutMethodInternational: React.FC = () => {
  const history = useHistory();

  return (
    <SetupLayout
      onBack={() => {
        history.push("/member/settings/payment-methods");
      }}
      title="Where should we send your payouts?"
    >
      <SetupInternationalAccount
        onSubmit={() => {
          history.push("/member/settings/payment-methods");
        }}
      />
    </SetupLayout>
  );
};
